import RolePlayDetailComponent from "../../../components/NewDesign/RolePlay/RolePlayDetailComponent"
import Page from "../../../components/Page"


const TourDetailPage = () => {
    return (
        <Page>
            <RolePlayDetailComponent />
        </Page>
    )
}

export default TourDetailPage